import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment.development';

const HOST = environment.host;

@Injectable({
  providedIn: 'root'
})
export class CertificatesService {
  private http = inject(HttpClient);
  certificates: { courseId: string, pdfUrl: string }[] | any = [];
  private certificatesSubject: BehaviorSubject<{ courseId: number, pdfUrl: string, nameCourse: string }[]> = new BehaviorSubject<{ courseId: number, pdfUrl: string, nameCourse: string }[]>([]);
  certificates$ = this.certificatesSubject.asObservable();
  hasCertificates$: Subject<boolean> = new Subject<boolean>();

  constructor() { }

  validateCertificate(idCourse:any, idStudent:any): Observable<any> {
    const url = `${HOST}/api/validate-certificate/${idCourse}/${idStudent}`
    return this.http.get(url)
  }

  generateCertificate(idCourse:any, idStudent:any):string{
    const url = `${HOST}/api/certificates?c=${idCourse}&u=${idStudent}`
    return url;
  }

  updateCertificates(certificates: { courseId: number, pdfUrl: string, nameCourse: string }[]) {
    this.certificatesSubject.next(certificates);
  }
}
